import { AccessContext } from "lego-gui-lib";
import {
  Required,
  Schema,
  TextField,
  RemoteDataSource,
  ForeignKeyField,
  DynamicColumn
} from "lego-gui-lib/lib";
import { createContext } from "react";
import { mainStore, api } from "../../core/mainStore";
import { CustomerFK } from "../customer/schema";
import get from "lodash/get";
import {
  onVisibilityChange,
  VisibilityEnum,
  VisibilityType,
  withVisibility
} from "../../common/common";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";
import { ContextAwareListDataSource } from "../../common/ContextAwareListDataSource";

const auth = mainStore.auth;

//todo - add SanRefFk

export const CalendarSchema = new Schema<DynamicColumn>({
  fields: [
    {
      name: "name",
      title: t("common:name"),
      type: TextField(Required)
    },
    {
      name: "visibility",
      title: t("common:visibility"),
      type: VisibilityEnum(),
      readonly: () => !auth.isAdmin()
    },
    {
      name: "customerRef",
      title: t("hns:customer:domain"),
      type: CustomerFK,
      if: (ctx: AccessContext) =>
        auth.isAdmin() && get(ctx, "data.visibility") === VisibilityType.PRIVATE
    }
  ],
  primaryKey: ["id"],
  defaultSort: { sort: "visibility", order: "desc" },
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const CalendarColumns = CalendarSchema.extend({
  customerRef: {
    type: CustomerFK,
    if: () => auth.isAdmin()
  }
});

export const CreateCalendarSchema = CalendarSchema.extend({
  visibility: {
    type: VisibilityEnum(),
    onChange: onVisibilityChange
  },
  customerRef: {
    if: (ctx: AccessContext) =>
      auth.isAdmin() && get(ctx, "data.visibility") === 1
  }
});

export const EditCalendarSchema = CreateCalendarSchema.extend({
  name: {
    readonly: (ctx: AccessContext) =>
      !auth.isAdmin() && get(ctx, "data.visibility") === 0
  },
  visibility: { readonly: true },
  customerRef: { readonly: true }
});

mainStore.calendar = RemoteDataSource.create({
  api: api,
  name: "calendar",
  schema: CalendarSchema,
  url: "/calendars",
  commons: mainStore.commons
});

export const calendarContext = createContext(mainStore.calendar);

mainStore.calendarFk = ContextAwareListDataSource.clone(mainStore.calendar, {
  observableFieldRef: "customerRef",
  observableDataSource: "customer"
});

export const customerCalendarContext = createContext(mainStore.calendarFk);

export const CalendarFK = ForeignKeyField(
  {
    dataSource: mainStore.calendarFk,
    searchField: "name",
    labelField: withVisibility(),
    valueField: "id",
    minWidth: 70
  },
  Required
);

export const CalendarFKNotRequired = ForeignKeyField({
  dataSource: mainStore.calendarFk,
  searchField: "name",
  labelField: withVisibility(),
  valueField: "id",
  minWidth: 70
});
